// src/screens/ShippingPolicyPage.jsx
import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const ShippingPolicyPage = () => {
  return (
    <>
      <Header />
      <div className="page-with-footer">
        <main className="page-main">
          <div className="site-shell">
            <div className="site-shell-inner">
              <section className="pt-5 pb-2 text-center">
                <h1
                  className="fw-bold display-5 mb-3"
                  style={{ color: "#A30003" }}
                >
                  Política de Envío
                </h1>
                <p
                  className="text-muted fs-5 mx-auto"
                  style={{ maxWidth: "900px", color: "#A30003" }}
                >
                  En <strong>AltaModa</strong>{" "} gestionamos las entregas de manera ágil dentro de todo el territorio urbano.
                </p>
              </section>

              <section className="py-4">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      Las entregas se realizan en Valledupar, coordinadas previamente con el cliente. Los tiempos pueden variar según la disponibilidad y la zona.
                    </p>

                    <p className="fs-5 text-muted lh-lg" style={{ textAlign: "justify" }}>
                      El costo del domicilio se informa al momento de confirmar el pedido.
                    </p>

                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ShippingPolicyPage;
